var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"default-position-button"},[_c('div',{staticClass:"aisea-m-0 cursor-pointer position-icon",on:{"click":function($event){return _vm.backToDefault()}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }